export default "/assets/images/mila-room-showcase-01.8f44e311e5ed3714.jpg";